import { CompanyModule } from '../enums/companyModule.enum'
import { IModuleAccess, ICompanySettings } from '../models/Company'
import {
  PERFORMANCE_MANAGEMENT_REQUEST_TYPES,
  RequestType,
} from '../models/Request'

// Default module-access shape: everything enabled. The single source for the
// "all modules on" default, reused by the support backfill and the migration so
// the default can't drift across places.
export const DEFAULT_MODULE_ACCESS: IModuleAccess = {
  employerBranding: true,
  onboarding: true,
  performanceManagement: true,
}

// Single source of truth for the "absent = enabled" semantic. An absent
// settings/modules/key is treated as ENABLED, so existing companies (pre-migration)
// and the loading state keep everything visible. Takes settings (not a company) so
// both a lean backend ICompanyPure and a frontend ICompany can call it.
export const isModuleEnabled = (
  settings: ICompanySettings | undefined,
  module: CompanyModule
): boolean => settings?.modules?.[module] ?? true

// Whether a request of the given type should be surfaced for a company, based on
// its enabled modules: performance-management request types need the PM module,
// START_ONBOARDING needs the onboarding module, everything else is always shown.
// Single source for this rule (request badges/lists, weekly summaries, reminder
// emails) so the call sites can't drift.
export const isRequestTypeModuleEnabled = (
  settings: ICompanySettings | undefined,
  actionType: RequestType
): boolean => {
  if (PERFORMANCE_MANAGEMENT_REQUEST_TYPES.includes(actionType)) {
    return isModuleEnabled(settings, CompanyModule.PERFORMANCE_MANAGEMENT)
  }
  if (actionType === RequestType.START_ONBOARDING) {
    return isModuleEnabled(settings, CompanyModule.ONBOARDING)
  }
  return true
}
